export default {
  alert: {
    fontWeight: 300,
    mb: 4,
  },
  editCardHeader: {
    backgroundColor: 'background.light',
    borderRadius: '4px 4px 0 0',
    px: 2,
    py: 1.75,
  },
  editCardHeaderText: {
    color: 'text.dark',
    fontWeight: '400',
  },
  editCardBody: {
    border: '1px solid',
    borderColor: 'background.grey.blue_3',
    borderTop: 'none',
    display: 'flex',
    gap: 3,
    px: 2,
    py: 2.5,
  },
  timeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  timeBox: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '107px',
    mb: 3,
  },
  boxesDivider: {
    backgroundColor: 'background.grey.blue_3',
    minWidth: '1px',
    width: '1px',
  },
  teamsBox: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    gap: 2.5,
  },
  teamBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  buttonsWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: 3,
  },
};
